<template>
    <div class="container py-5">
        <h2>{{ $t('dataSpaceCreation') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link :to="{ name: 'dataspaces' }">
                        {{ $t('home') }}
                    </router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link :to="'/settings/dataspaces'">
                        {{ $t('dataSpaces') }}
                    </router-link>
                </li>
                <li class="breadcrumb-item">
                    {{ $t('create') }}
                </li>
            </ol>
        </nav>
        <div class="form-row mb-3">
            <div class="form-group col-md-3">
                <label for="name">{{ $t('dataSpaceName') }}</label>
                <input v-model="model.name" type="text" v-bind:class="['form-control', requiredCenter]" id="name"  placeholder="Enter Data Space name">
            </div>
        </div>
        <div class="row col-md-12">
            <label class="form-label">{{ $t('groups') }}</label>
            <div class="col-md-3" v-for="(item, i) in groups" :key="i">
                <div class="input-group mb-3">
                    <label class="form-control readonly" :for="'group_' + i">{{item.name}}</label>
                    <div class="input-group-text">
                        <input class="form-check-input mt-0" type="checkbox" :id="'group_' + i" @change="groupCheck(item, $event)" :checked="isGroupChecked(item)">
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-md-4">
                <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('save') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import dataSpaceApi from "../../../api/server/dataspace";
import GroupApi from "../../../api/server/group";

export default {
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.groups = await GroupApi.list();
        },
        async onSubmit() {
            if(this.model.name.length < 1){
                this.requiredName = "required"
                return;
            }

            if(this.model && this.model.name.length > 1){
                this.model.content = JSON.stringify(this.content);
                let dataSpace = await dataSpaceApi.dataSpaceCreate(this.model);
                this.$router.push({ name: 'dataspacedetail', params: { id: dataSpace.id } })
            }
               
        },
        groupCheck(group, event) {
            if(!this.content.groups)
                this.content.groups = [];
            if(event.target.checked) {
                var index =  this.content.groups.findIndex(f=>f.groupId == group.id);
                if(index < 0) {
                    this.content.groups.push({ "groupId": group.id })
                }
            } else {
                var index = this.content.groups.findIndex(f=>f.groupId == group.id);
                if(index >= 0) {
                    this.content.groups.splice(index, 1);
                }
            }
        },
        isGroupChecked(item) {
            return this.content["groups"]?.findIndex(f => f["groupId"] == item.id) >= 0;
        }
    },
    data() {
        return {
            groups: [],
            content: {},
            id: "Id",
            dataSpaces: "DataSpaces",
            requiredName: "",
            model: {
                name: "",
                content: "{}"
            }
        }
    }
};

</script>
